// TODO: deprecated - 請改用 storageKeys.ts 的 COOKIE_KEYS
export const COOKIE_NONCE = "hs_woo_nonce";

export const PLACEHOLDER_IMAGE = "/images/product-placeholder.png";

export const DEFAULT_MAX_QUANTITY = 99;

export const OFFICIAL_LINE = {
  LINK: "https://line.me/R/ti/p/@fkb4472p",
  AT_ID: "@fkb4472p",
};

export const OFFICIAL_EMAIL = "yuancoffee.tw@gmail.com";

export const COUNTRY_TW = "TW";

export const ROAST_ATTR_TAXONOMY = "pa_roast";
